import Can from '../Can';
import MonitoredDocumentViewer from '../MonitoredDocument/MonitoredDocumentViewer/MonitoredDocumentViewer.container';
import PropTypes from 'prop-types';
import React from 'react';

// COMPONENT
export const MonitoredDocumentVersionPage = ({ match, location }) => (
    <div className="p-3">
        <Can I="update" a="Document">
            <MonitoredDocumentViewer
                documentId={match.params.docId}
                versionId={match.params.versionId}
                backLink={
                    location.state && location.state.backLink ? location.state.backLink : null
                }
            />
        </Can>
    </div>
);

MonitoredDocumentVersionPage.propTypes = {
    match: PropTypes.shape({
        params: PropTypes.shape({
            docId: PropTypes.string,
            versionId: PropTypes.string,
        }),
    }),
    location: PropTypes.shape({
        state: PropTypes.shape({
            backLink: PropTypes.string,
        }),
    }),
};
